export const allowedProjectNameChars = '.:\\(\\)-\\s_';

export function hasInvalidCharsInProjectName(projectName) {
    var regex = new RegExp(`^[a-zA-Z0-9${allowedProjectNameChars}]+$`);
    return !!!regex.test(projectName) || !/^[\000-\177]*$/.test(projectName);
}

export function replaceNotAllowedCharsInProjectName(projectName) {
    return projectName.replace(new RegExp(`[${allowedProjectNameChars}]`, 'gi'), '_');
}